import React from 'react';
import { connect } from 'react-redux';

import * as actions from '../../actions/school/school-listings';

import SchoolListingComponent from '../../components/app/School/SchoolListing';

const SchoolListing = (props) => {
  return (
    <SchoolListingComponent {...props} />
  );
};

export default connect(({ school, user }) => ({ schoolListing: school.schoolListings, user }), actions)(SchoolListing);

